import { render, staticRenderFns } from "./listChildren.vue?vue&type=template&id=1f832cbe&"
import script from "./listChildren.vue?vue&type=script&lang=js&"
export * from "./listChildren.vue?vue&type=script&lang=js&"
import style0 from "./listChildren.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports